#### Stricter end date validation on job ad edits

On 27 October 2023, the [`updatePostedPositionProfile` mutation] will be updated with stricter synchronous validation of the [`end` date].
Your software will receive a [`BAD_USER_INPUT` error] if the supplied date exceeds the maximum duration of the job ad,
with a response that looks similar to the following:

```json
{
  "errors": [
    {
      "message": "Invalid posting end date",
      "extensions": {
        "code": "BAD_USER_INPUT",
        "invalidFields": {
          "/input/positionProfile/postingInstructions/0/end": "Must not be more than 30 days from 2020-01-01T00:00:00.000Z"
        }
      }
    }
  ]
}
```

This validation rule has always been enforced on our other posting mutations and will not affect integrations that already limit the end date.
We have proactively reached out to partners that systematically provided invalid end dates to the SEEK API.
Other partners may review their job edit functionality to ensure that clients can view validation errors and correct the end date where necessary.

[`BAD_USER_INPUT` error]: /graphql/error-responses#bad_user_input
[`end` date]: /schema/named-type/UpdatePostingInstructionInput#/field/end
[`updatePostedPositionProfile` mutation]: /schema/mutation/updatePostedPositionProfile
